<template>
	<div>
		<div class="mian" v-loading="loading">
			<div class="tabbox fcc">
				<div :class="category_id == '1'?'tab-a fcc':'tab fcc'" @click="changecategory_id('1')">工程专区</div>
				<div :class="category_id == '2'?'tab-a fcc':'tab fcc'" @click="changecategory_id('2')">物资采购</div>
			</div>
			<div class="list fcs" v-for="(item,index) in list" :key="index" @click="godetails(item.id)">
				<div class="title">{{item.title}}</div>
				<div class="time">{{item.createtime}}</div>
			</div>
			<div class="fcc" style="margin: 50px 0;">
				<el-pagination background layout="prev, pager, next" :page-size="20" :total="total"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				category_id: '1', //1=工程专区,2=物资采购
				page: 1,
				list: [],
				total: 0
			}
		},
		watch: {
			$route(to, from) {
				this.category_id = this.$route.query.id
				this.getlist();
			}
		},
		created() {
			if (this.$route.query.id) {
				this.category_id = this.$route.query.id
			}
			this.getlist();
		},
		methods: {
			//切换分类
			changecategory_id(category_id) {
				this.category_id = category_id;
				this.getlist();
			},
			//点击分页
			handleCurrentChange(val) {
				this.page = val;
				this.list = [];
				this.getlist();
			},
			//获取招标公告
			getlist() {
				let data = {
					page: this.page,
					limit: 20,
					category_id: this.category_id
				}
				this.loading = true;
				this.$api.home.notice(data).then(res => {
					if (res.code == 1) {
						this.list = res.data.list;
						this.total = res.data.total;
					}
					this.loading = false;
				})
			},
			//跳转详情
			godetails(id) {
				this.$api.home.noticeinfo({
					notice_id: id
				}).then(res => {
					if (res.code == 1) {
						this.$router.push({
							path: '/details',
							query: {
								id: id
							}
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.mian {
		width: 1200px;
		margin: 50px auto;
	}

	.mian .tabbox {
		cursor: pointer;
		margin-bottom: 50px;
	}

	.mian .tabbox .tab {
		width: 156px;
		height: 38px;
		background: #ECECEC;
		border-radius: 6px;
		font-size: 16px;
		margin-left: 20px;
	}

	.mian .tabbox .tab-a {
		width: 156px;
		height: 38px;
		background: #0B457A;
		border-radius: 6px;
		font-size: 16px;
		color: #ffffff;
		margin-left: 20px;
	}

	.mian .list {
		width: 1000px;
		height: 54px;
		margin: 0 auto;
		border-bottom: #ADADAD dashed 1px;
		cursor: pointer;
	}

	.mian .list:hover {
		color: #0B457A;
		font-weight: bold;
	}

	.mian .list:hover .time {
		color: #0B457A;
	}

	.mian .list .title {
		width: 750px;
		font-size: 16px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.mian .list .time {
		font-size: 16px;
		color: #333333;
	}
</style>